import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Typography, Box, Modal, Snackbar, makeStyles, Button, Grid, TextField } from '@material-ui/core';
import { Stack, useMediaQuery } from '@mui/material';
import { api_call, getDeviceDistanceUnit, getDistanceWithUnit, getToken } from '../helpers/untils';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '360px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  maxHeight: '100vh',
  overflowY: 'auto'
};
const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  }

}));

const EditOdometerModal = (props) => {
  const { open, setOpen, device, distance_unit, deviceOdometer, setDeviceOdometer } = props;
  const session = getToken();
  const unitStr = getDeviceDistanceUnit(distance_unit)
  const [apiLoading, setApiLoading] = useState(false)
  const handleModalClose = () => {
    setOpen("")
  }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const showToast = (msg) => {
    setSnackbarOpen(true)
    setToastMessage(msg)
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    if (open) {
      setValue(Number(deviceOdometer))
    }
  }, [open])

  const [value, setValue] = useState("")

  const onClickSaveSetting = async () => {
    setApiLoading(true)
    const url = `/api/installer-update-odometer`;
    const payload = {
      odometer: value,
      distance_unit: distance_unit,
      token: session
    }
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    setApiLoading(false)
    if (response.ok) {
      const apiRes = await response.json();
      const device = apiRes.device;
      setDeviceOdometer(device.odometer);
    }
    handleModalClose()
  }

  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />
          <Stack direction={`row`} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">{`Edit Odometer`}</Typography>
            {/* <IconButton size="small" onClick={() => handleModalClose()}><CloseIcon /></IconButton> */}
          </Stack>
          <Box sx={{ paddingTop: 10 }}>
            <Grid container spacing={1} justifyContent="flex-start">
              <Grid item xs={12} sm={12}>
                <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={2}>
                  <TextField
                    margin="small"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    label=""
                    variant="filled"
                    type="number"
                    fullWidth
                  //style={{maxWidth:'180px'}}
                  />
                  <Typography>{unitStr}</Typography>
                </Stack>

              </Grid>
              <Grid item xs={12} sm={12}>
                <Stack direction={`row`} spacing={1} sx={{ justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                  <Button
                    type="button"
                    color="primary"
                    variant="contained"
                    size="large"
                    disabled={apiLoading}
                    onClick={() => onClickSaveSetting()}
                  >
                    Save
                  </Button>
                  <Button
                    type="button"
                    color="primary"
                    variant="outlined"
                    size="large"
                    onClick={() => handleModalClose()}
                  >
                    Cancel
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default EditOdometerModal;
